import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  progressButtonWrapper: {
    position: 'relative',
  },
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  progressContainer: {
    marginTop: -24,
    marginLeft: -24,
  },
  progressButton: {
    marginTop: -12,
    marginLeft: -12,
  },
  container: {
    height: '100vh',
  },
  form: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});
